<div [formGroup]="form" class="container">
  <mat-form-field class="status-select">
    <mat-select [formControlName]="controlName" (selectionChange)="changed($event)">
      @for (job of jobs; track job) {
        <mat-option [value]="job.value" >{{
          job.name
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
